import { render, staticRenderFns } from "./member-purchase-order-detail-modal.vue?vue&type=template&id=3a3dd804&"
import script from "./member-purchase-order-detail-modal.vue?vue&type=script&lang=js&"
export * from "./member-purchase-order-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports